import React, { createContext, useContext, useEffect, useState } from "react"
import { SessionData, UserApi } from "@sb1finans/new-api/dist"
import { ConfigContext } from "./ConfigProvider"
import LoadingContainer from "./LoadingContainer"

export enum AuthLevel {
    LOW, HIGH, NONE
}

interface UserContextProps {
    login: (authLevel?: AuthLevel) => void
    logout: (callback: () => void) => void
    isLoggedIn: boolean
    pending: boolean
    authLevel: AuthLevel
}

const defaultUserContext: UserContextProps = {
    login: (authLevel?: AuthLevel) => {},
    logout: () => {},
    isLoggedIn: false,
    pending: false,
    authLevel: AuthLevel.NONE
}

interface UserContextProviderProps  {
    userApi: UserApi
}

export const UserContextProvider: React.FC<UserContextProviderProps> = ({children, userApi}) => {
    console.info("Setting up UserContext.")

    const config = useContext(ConfigContext)
    const [sessionData, setSessionData] = useState<SessionData | undefined>(undefined)

    useEffect(() => {
        userApi.getProfile().then((res) => {
            console.info("Got profile data.", res)
            
        })
    }, [])

    console.log(sessionData)

    const userContext = defaultUserContext

    return userContext.pending ? 
        (
            <LoadingContainer />
        ) : (
        <UserContext.Provider value={userContext}>
            {children}
        </UserContext.Provider>
        )
}

export const UserContext = createContext<UserContextProps>(defaultUserContext)